/**
 * Lógica de eliminación de cuentas en la grilla de Mi Perfil (PBI 85569).
 * Las solicitudes visuales (agregadas desde el modal pero aún no persistidas)
 * no tienen idSolicitud, pero se eliminan solo de la grilla.
 */

/**
 * Determina si se puede abrir el modal de baja para un registro de la grilla.
 * Una solicitud Pendiente sin idSolicitud y sin flag visual significa que la
 * grilla quedó con datos viejos: se muestra error y no se abre el modal.
 * @param {Object} item - Fila de la grilla de cuentas.
 * @returns {boolean} true si se puede proceder con la baja.
 */
export const puedeEliminarCuenta = (item) => {
  const esSolicitudPendiente = item.estado === 'Pendiente'

  return !(!(item.esSolicitudVisual || item.idSolicitud) && esSolicitudPendiente)
}

/**
 * Filtra las solicitudes visuales quitando la que coincide con la cuenta a
 * eliminar (mismo contrato Y misma CUIT).
 * @param {Array} solicitudes - Solicitudes pendientes visuales.
 * @param {Object} cuenta - Cuenta a eliminar.
 * @returns {Array} Solicitudes restantes.
 */
export const quitarSolicitudVisual = (solicitudes, cuenta) =>
  solicitudes.filter((solicitud) => solicitud.contrato !== cuenta.contrato || solicitud.cuit !== cuenta.cuit)
